import React from 'react';
import { Button, Glyphicon } from 'react-bootstrap';
import $ from 'jquery';

export default class SideMenu extends React.Component {
  constructor(props) {
    super(props);
    this.scrollToTop = this.scrollTo.bind(this, 'main-body');
    this.scrollToDocuments = this.scrollTo.bind(this, 'Documents');
  }
  scrollTo(id) {
    const offSet = $(`#${id}`).offset();
    if (offSet !== undefined) {
      $('html, body').animate({
        scrollTop: parseInt(offSet.top - 120, 10),
      }, 400);
    }
  }

  render() {
    let productButtons = [];
    let productButtonsCount = 1;
    if (this.props.products) {
      productButtons = this.props.products.map((prod, idx) =>
        (prod.get('hidden') ? '' :
          <div key={prod.get('id') || idx} style={{ display: 'inline-grid' }}>
            <Button
              bsStyle="primary"
              title={`Product №${productButtonsCount}`}
              onClick={() => this.scrollTo(`deal_atom_${idx}`)}
            >
              {productButtonsCount++}
            </Button>
          </div>)
      );
    }
    return (
      <div className="side-menu">
        <Button bsStyle="primary" title="Head" onClick={this.scrollToTop}>
          <Glyphicon glyph="upload" />
        </Button>
        {productButtons}
        <Button bsStyle="primary" title="Documents" onClick={this.scrollToDocuments}>
          <Glyphicon glyph="paperclip" />
        </Button>
      </div>
    );
  }
}
SideMenu.propTypes = {
  products: React.PropTypes.object,
};
